<form [formGroup]="otpForm" (ngSubmit)="addOtp()">
    <div class="form-container">
      <div class="form-field">
        <label>{{'referentiels.list.otpProperties.eotp.header' | transloco }}<span class="required">*</span></label>
        <input pInputText formControlName="eotp" />
        <small class="p-error block">
          @if (otpForm.controls.eotp.errors?.required) {
            <p-message *ngIf="otpForm.controls['eotp'].invalid && otpForm.controls['eotp'].touched" severity="danger" text="Le code eotp est requis."></p-message>
          } 
        </small>
      </div>
  
      <div class="form-field">
        <label>{{ 'referentiels.list.otpProperties.libelle.header'| transloco }}<span class="required">*</span></label>
        <input pInputText formControlName="designation" />
        <small class="p-error block">
          <p-message *ngIf="otpForm.controls['designation'].invalid && otpForm.controls['designation'].touched" severity="danger" text="Le champ pour la désignation est requis."></p-message>
        </small>
      </div>
    </div>
  
    <div class="button-container">
      <p-button pRipple label="{{ 'button.cancel' | transloco }}" [rounded]="true" (onClick)="close(false)" />
      <p-button pRipple label="{{ 'button.validate' | transloco}}" [rounded]="true" type="submit" [disabled]="otpForm.invalid" />
    </div>
  
    <div *ngIf="submitting" class="loading-spinner">
      <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
    </div>
  </form>
  <p-toast />
  